var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1492_92606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.241 0 0 4.953 0 11.64C0 15.138 1.434 18.162 3.768 20.25C3.963 20.424 4.083 20.67 4.089 20.934L4.155 23.07C4.15981 23.2272 4.20314 23.3807 4.2812 23.5172C4.35926 23.6537 4.46965 23.769 4.60267 23.8528C4.73569 23.9366 4.88726 23.9865 5.04408 23.9981C5.20089 24.0096 5.35814 23.9825 5.502 23.919L7.884 22.869C8.085 22.779 8.313 22.764 8.526 22.821C9.621 23.121 10.785 23.283 12 23.283C18.759 23.283 24 18.33 24 11.643C24 4.956 18.759 0 12 0Z",
    fill: "url(#paint0_radial_1492_92606)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79413 15.045L8.31913 9.45297C8.45174 9.24244 8.62655 9.06168 8.83254 8.92211C9.03853 8.78255 9.27121 8.6872 9.5159 8.6421C9.7606 8.59699 10.012 8.60311 10.2542 8.66006C10.4964 8.71701 10.7242 8.82355 10.9231 8.97297L13.7281 11.076C13.8534 11.1697 14.0057 11.2201 14.1621 11.2196C14.3186 11.2191 14.4706 11.1676 14.5951 11.073L18.3811 8.19897C18.8851 7.81497 19.5451 8.42097 19.2091 8.95797L15.6811 14.547C15.5485 14.7575 15.3737 14.9383 15.1677 15.0778C14.9617 15.2174 14.7291 15.3127 14.4844 15.3578C14.2397 15.403 13.9883 15.3968 13.7461 15.3399C13.5039 15.2829 13.2761 15.1764 13.0771 15.027L10.2721 12.924C10.1469 12.8302 9.99456 12.7798 9.83813 12.7803C9.6817 12.7809 9.52971 12.8324 9.40513 12.927L5.61913 15.801C5.11513 16.185 4.45513 15.582 4.79413 15.045Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1492_92606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.02 24) scale(26.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1492_92606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.1c672a9c8bff3b5ad37195f27d78884e.svg";
export { ForwardRef as ReactComponent };